import { FocusedSectionAction, SET_POP_DATA } from "../types/FocusedSectionAction";

const focusSection: (data: string) => FocusedSectionAction = (data: string) => {
  return {
    type: "FOCUS_SECTION",
    data: data,
  };
};

const setPopUpData = (data: any) => ({
  type: SET_POP_DATA,
  data
});

export { focusSection, setPopUpData };
